var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5454",
    "data-name": "Group 5454",
    transform: "translate(-1192.5 -285)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(1192.5 285)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(1205.623 244.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5428",
    "data-name": "Group 5428",
    transform: "translate(0 62.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5427",
    "data-name": "Group 5427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67640",
    "data-name": "Path 67640",
    d: "M12.564,154.015a1.35,1.35,0,0,1-1.4,0L0,147.2v9.059a3.507,3.507,0,0,0,3.506,3.506H20.248a3.507,3.507,0,0,0,3.506-3.506V147.2Z",
    transform: "translate(0 -147.2)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5430",
    "data-name": "Group 5430",
    transform: "translate(0.112 57.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5429",
    "data-name": "Group 5429",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67641",
    "data-name": "Path 67641",
    d: "M22.184,57.088H5.441a3.485,3.485,0,0,0-3.393,2.748l11.779,7.179,11.751-7.179A3.485,3.485,0,0,0,22.184,57.088Z",
    transform: "translate(-2.048 -57.088)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9c381af43ec2894ef9592555f8e44bed.svg";
export { ForwardRef as ReactComponent };